import React from 'react';

export default function VenueExplorer({ data, id }) {
  // console.log(data.baseUrl);
  const isBrowser = typeof window !== 'undefined';
  const [iframeUrl, setIframeUrl] = React.useState('');

  React.useEffect(() => {
    if (isBrowser) {
      const currPath = window.location.href;
      const venueId = currPath.split('#')[1];
      setIframeUrl(venueId ? `${data.baseUrl}#${venueId}` : data.baseUrl);
    }
  }, []);

  return (
    !!iframeUrl && (
      <iframe
        className="explor-frame"
        scrolling="no"
        title="Venue explorer"
        src={iframeUrl}
        id={id}
      />
    )
  );
}
